import { ConfigurationControllerUrl, apiURL } from ".";
import { AppVersionDto, PopupInfoDto, ServiceResponseDto } from "../Models";
import { AuthService } from "./AuthService";

export class ConfigurationService {
  authService: AuthService = new AuthService(apiURL.backofficeApiUrl);
  async SetPopupInfo(popupInfo: PopupInfoDto) {
    var url = `${ConfigurationControllerUrl}/AddPopupInfo`;
    await this.authService.PostAsync(url, popupInfo);
  }
  async GetPopupInfo(): Promise<ServiceResponseDto<PopupInfoDto>> {
    var url = `${ConfigurationControllerUrl}/GetPopupInfo`;
    var res = await this.authService.GetAsync<ServiceResponseDto<PopupInfoDto>>(
      url
    );
    return res;
  }
  async SetAppVersion(appVersion: AppVersionDto) {
    var url = `${ConfigurationControllerUrl}/SetAppVersion`;
    await this.authService.PostAsync(url, appVersion);
  }
  async GetAppVersion(): Promise<ServiceResponseDto<AppVersionDto>> {
    var url = `${ConfigurationControllerUrl}/GetAppVersion`;
    var res = await this.authService.GetAsync<
      ServiceResponseDto<AppVersionDto>
    >(url);
    return res;
  }

  async GetDazeSupportedLanguages(): Promise<ServiceResponseDto<string[]>> {
    var url = `${ConfigurationControllerUrl}/GetSupportedLanguages`;
    var res = await this.authService.GetAsync<ServiceResponseDto<string[]>>(
      url
    );
    return res;
  }
}
